import React, { useRef, useState } from 'react'
import { useClickAway } from 'react-use'

import MorePropTypes from '../../../utils/MorePropTypes'
import s from './Tooltip.module.scss'
import TooltipContent from './TooltipContent'

export default function MobileTooltip({ children, text, title }) {
  const anchorRef = useRef(null)
  const [anchorClicked, setAnchorClicked] = useState(false)
  const [tooltipStyle, setTooltipStyle] = useState({})

  useClickAway(anchorRef, () => setAnchorClicked(false))

  return (
    <div className={s.container}>
      <button className={s.anchor} onClick={handleClick} ref={anchorRef}>
        {children}
      </button>
      {anchorClicked && (
        <>
          <div className={s.tooltip} style={tooltipStyle}>
            <TooltipContent text={text} title={title} />
          </div>
          <div className={s.arrow} />
        </>
      )}
    </div>
  )

  function handleClick() {
    positionTooltip()
    setAnchorClicked(true)
  }

  function positionTooltip() {
    const rightSidePadding = 16
    const tooltipWidth = 280
    const { x, width } = anchorRef.current.getBoundingClientRect()
    const anchorCenterX = x + width / 2
    const distanceToRightSide = window.innerWidth - anchorCenterX
    const minDistanceToRightSideToFitTooltip = tooltipWidth / 2 + rightSidePadding

    if (distanceToRightSide < minDistanceToRightSideToFitTooltip) {
      const shift = distanceToRightSide - minDistanceToRightSideToFitTooltip
      setTooltipStyle({ ...tooltipStyle, transform: `translateX(calc(${shift}px - 50%))` })
    } else {
      setTooltipStyle({ ...tooltipStyle, transform: `translateX(-50%)` })
    }
  }
}

MobileTooltip.propTypes = MorePropTypes.tooltipProps.isRequired
